import MobileTitleBar from "components/MobileTitleBar"
import React, { Component } from "react"
import { Container, Image } from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import shop from "shop/shop"
import Responsive from "react-responsive"
import { useLocation } from "react-router-dom"

export default class HomePageV2 extends Component {

    render() {
        this.props.history.push("/return")
        return (
            <div>
                <WordPressContainer slug="startseite"/>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/HomePageV2.js